import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetUserTransactionsAdmin($input: GetUserTransactionsAdminInput!) {
    getUserTransactionsAdmin(input: $input) {
      count
      yearCounts {
        year
        count
      }
      customer {
        id
        first_name
        last_name
        email
        cellphone
        customer_since
        zipcode
        city
        state
        has_season_pass
        lifetime_value
      }
      results {
        id
        fee
        refund
        discount
        credit
        total
        profit
        purchase_date
        status
        order_source
        payment_method
        users {
          user {
            id
            name
            first_name
            last_name
            email
            cellphone
          }
          tickets {
            id
            ticket_id
            name
            price
            refunded
            credited
            type
          }
        }
        event {
          id
          name
          start_date
          end_date
          status
          tickets {
            id
            name
            price
          }
        }
        track {
          id
          name
        }
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match, location }) => {
    const search = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    // Convert year to number if present
    const input = {
      user_id: Number(match.params.id),
      ...search,
    };

    if (input.year) {
      input.year = Number(input.year);
    }

    return {
      variables: {
        input,
      },
      fetchPolicy: 'cache-and-network',
    };
  },
});
